import { useState } from 'react'
import { useDispatch } from 'react-redux'
import Select from 'react-select'
import Modal from 'components/misc/Modal'
import Button from 'components/forms/Button'
import Header from 'components/typography/Header'
import Expand from 'components/misc/Expand'

import styles from './styles/ExportModal.css'

const FORMAT_OPTIONS = [
  {
    label: 'ris',
    value: 'ris'
  },
  {
    label: 'bibtex',
    value: 'bib'
  },
  {
    label: 'csv',
    value: 'csv'
  }
]

const DIRECTION_OPTIONS = [
  {
    label: 'References in article',
    value: 'from'
  },
  {
    label: 'Citations to article',
    value: 'to'
  }
]

const Selector = ({ label, options, value, onChange }) => (
  <label className={styles.selector}>
    <span className={styles.label}>
      {label}
    </span>
    <Select className={styles.selectorInput} options={options} value={value} onChange={onChange} />
  </label>
)

const ExportModal = ({
  actionCreator,
  show,
  title,
  toggleDispatchFn,
  toggleFn,
  exportFn,
  defaultFormat,
  supportedFormats = ['csv', 'bib', 'ris'],
  supportedParams = ['format', 'direction']
}) => {
  const dispatch = useDispatch()
  const formatOptions = FORMAT_OPTIONS.filter(opt => supportedFormats.includes(opt.value))
  const [formatValue, setFormatValue] = useState(formatOptions.find(opt => opt.value === defaultFormat) || formatOptions[0])

  const [directionValue, setDirectionValue] = useState(DIRECTION_OPTIONS[0])

  const hasDirection = formatValue.value !== 'csv' && supportedParams.includes('direction')

  const handleExport = () => {
    const params = {
      format: formatValue.value
    }

    if (hasDirection) {
      params.direction = directionValue.value
    }
    if (actionCreator) {
      dispatch(actionCreator(params))
    }
    if (toggleDispatchFn) {
      dispatch(toggleDispatchFn())
    }
    if (exportFn) {
      exportFn(params)
    }
    if (toggleFn) {
      toggleFn()
    }
  }

  const handleToggle = () => {
    if (toggleDispatchFn) {
      dispatch(toggleDispatchFn())
    }
    if (toggleFn) {
      toggleFn()
    }
  }

  return (
    <Modal className={styles.modal} toggle={handleToggle} show={show}>
      <Header level={3} className={styles.header}>{title}</Header>
      <Selector label='Format' options={formatOptions} value={formatValue} onChange={setFormatValue} />
      <Expand show={hasDirection} width='auto' extraStyle={{ overflow: 'visible' }}>
        <Selector label='Direction' options={DIRECTION_OPTIONS} value={directionValue} onChange={setDirectionValue} />
      </Expand>
      <Button className={styles.button} color='blue' onClick={handleExport}>Export</Button>
    </Modal>
  )
}

export default ExportModal
